import Style from "./style"

import PageTitle from "widget/PageTitle"
import Pagenation from "widget/Pagenation"

import useGetMediaList from "entity/column/useGetMediaList"
import timestampCalculator from "shared/lib/timestampCalculator"

const MediaList = () => {

    const [mediaList] = useGetMediaList()

    return (
        <Style.Wrapper>
            <PageTitle>미디어</PageTitle>

            <Style.List>
                {mediaList?.data?.media_list?.map(elem =>
                    <Style.Element onClick={() => window.location.href = elem?.url}>
                        <img src={elem?.img} />
                        <div>
                            <h2>{elem?.title}</h2>
                            <p>{timestampCalculator(elem?.created_at)}</p>
                        </div>
                    </Style.Element>
                )}
                {mediaList?.data?.media_list?.length < 1 && <Style.Option>아직 미디어가 작성되지 않았습니다.</Style.Option>}
            </Style.List>

            <Pagenation maxPage={mediaList?.data?.max_page} />

        </Style.Wrapper>
    )
}

export default MediaList